import { useNavigate } from "react-router";

import { MELHOUS_PATH, VIEW_HOME } from "../constants";

function getViewPath(view) {
  return view === VIEW_HOME ? MELHOUS_PATH : `${MELHOUS_PATH}/${view}`;
}

function useOpenView() {
  const navigate = useNavigate();
  return function openView(view) {
    navigate(getViewPath(view));
  };
}

export default useOpenView;
